var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "disable_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".disable_svg__dt{clip-path:url(#disable_svg__ds)}.disable_svg__du{fill:none}.disable_svg__dv{fill:#f7f7f7}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "disable_svg__ds"
  }, /*#__PURE__*/React.createElement("path", {
    className: "disable_svg__du",
    d: "M54.88,215c0,88.43,71.69,160.12,160.12,160.12s160.12-71.69,160.12-160.12S303.43,54.88,215,54.88,54.88,126.57,54.88,215h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "disable_svg__dt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "disable_svg__du",
    d: "M215,381.12c-91.6,0-166.12-74.52-166.12-166.12S123.4,48.88,215,48.88s166.12,74.52,166.12,166.12-74.52,166.12-166.12,166.12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "disable_svg__dv",
    d: "M215,42.88c-94.91,0-172.12,77.21-172.12,172.12s77.21,172.12,172.12,172.12,172.12-77.21,172.12-172.12S309.91,42.88,215,42.88ZM363.12,215c0,36.53-13.3,70-35.29,95.85L119.15,102.18c25.85-22,59.33-35.3,95.85-35.3,81.67,0,148.12,66.45,148.12,148.12ZM66.88,215c0-36.53,13.3-70,35.29-95.85l208.68,208.68c-25.85,22-59.33,35.3-95.85,35.3-81.67,0-148.12-66.45-148.12-148.12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.875ecf4b719e34a764b8938bb294f051.svg";
export { ForwardRef as ReactComponent };